module.exports = __webpack_public_path__ + "static/img/dividenden-370x290.6dbcef14.jpg";